import { render, staticRenderFns } from "./PuzzleLoopPage.vue?vue&type=template&id=ddcfdf98&"
import script from "./PuzzleLoopPage.vue?vue&type=script&lang=js&"
export * from "./PuzzleLoopPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports